export default __webpack_public_path__ + "static/media/global.c0acee55.svg";